import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "./locales/fr.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import it from "./locales/it.json";
import de from "./locales/de.json";
import nl from "./locales/nl.json";
import pt from "./locales/pt.json";
import pl from "./locales/pl.json";
import sv from "./locales/sv.json";
import da from "./locales/da.json";
import nb from "./locales/nb.json";
import fi from "./locales/fi.json";
import ar from "./locales/ar.json";
import tr from "./locales/tr.json";

// Socle i18n multilingue. Français par défaut. 12 langues UE + arabe (RTL) + turc.
// Le libellé de chaque langue est affiché dans sa propre langue.
// `ready: true` = langue 100% relue et adaptée au vocabulaire immobilier.
// Les langues non prêtes restent listées mais verrouillées (« bientôt disponible »)
// afin de NE JAMAIS afficher un mélange français / langue étrangère.
export const RTL_LANGUAGES = ["ar"];
export const SUPPORTED_LANGUAGES = [
  { code: "fr", label: "Français", ready: true },
  { code: "en", label: "English", ready: true },
  { code: "es", label: "Español", ready: true },
  { code: "de", label: "Deutsch", ready: true },
  { code: "it", label: "Italiano", ready: true },
  { code: "nl", label: "Nederlands", ready: true },
  { code: "pt", label: "Português", ready: true },
  { code: "pl", label: "Polski", ready: true },
  { code: "sv", label: "Svenska", ready: true },
  { code: "da", label: "Dansk", ready: true },
  { code: "nb", label: "Norsk", ready: true },
  { code: "fi", label: "Suomi", ready: true },
  { code: "ar", label: "العربية", ready: true },
  { code: "tr", label: "Türkçe", ready: true },
];
export const READY_LANGUAGES = SUPPORTED_LANGUAGES.filter((l) => l.ready).map((l) => l.code);

export function applyDirection(lng) {
  const dir = RTL_LANGUAGES.includes(lng) ? "rtl" : "ltr";
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lng);
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      es: { translation: es },
      it: { translation: it },
      de: { translation: de },
      nl: { translation: nl },
      pt: { translation: pt },
      pl: { translation: pl },
      sv: { translation: sv },
      da: { translation: da },
      nb: { translation: nb },
      fi: { translation: fi },
      ar: { translation: ar },
      tr: { translation: tr },
    },
    fallbackLng: "fr",
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false },
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"] },
  });

// Direction RTL/LTR au démarrage et à chaque changement de langue.
applyDirection(i18n.language || "fr");
i18n.on("languageChanged", (lng) => applyDirection(lng));

// Garde anti-mélange : si la langue résolue n'est pas 100% prête, on bascule sur une
// langue complète (fr si navigateur francophone, sinon en) — jamais de FR/étranger mixé.
const _resolved = (i18n.language || "fr").slice(0, 2);
if (!READY_LANGUAGES.includes(_resolved)) {
  const nav = (typeof navigator !== "undefined" ? navigator.language || "" : "").toLowerCase();
  i18n.changeLanguage(nav.startsWith("fr") ? "fr" : "en");
}

export default i18n;
